import * as z from "zod";
import { mutator } from "./mutator";

const deleteUsageBudgetSchema = z.object({
  id: z.string(),
});

export const deleteUsageBudget = mutator({
  schema: deleteUsageBudgetSchema,
  resolve: {
    budget: { kind: "connectorUsageBudget", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { budget } }) => {
    await tx.mutate.connectorUsageBudgets.delete({ id: budget.id });
  },
});
